import { useEffect, useRef } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://hipobuyspreadsheets.space';

export function useJsonLd(schema: Record<string, unknown>) {
  const schemaRef = useRef(schema);
  schemaRef.current = schema;

  useEffect(() => {
    const id = `readdy-seo-${Math.random().toString(36).slice(2, 9)}`;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemaRef.current);
    script.id = id;
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);
}

export function getSiteUrl(): string {
  return SITE_URL;
}